/* V2 presentation only. Native Shopify owners retain data, mutations and recovery. */
(() => {
  if (!document.body.classList.contains('hm-v2')) return;
  const menus = new WeakSet();
  const footerGroups = new WeakSet();
  const footerNarrow = matchMedia('(max-width: 749px)');
  function presentFooterGroup(group, narrow) {
    group.querySelector('summary').tabIndex = narrow ? 0 : -1;
    group.open = !narrow || group.contains(document.activeElement);
  }
  function initialize(root) {
    root.querySelectorAll('.hm-navigation details').forEach(details => {
      if (menus.has(details)) return;
      menus.add(details);
      details.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches) details.open = true;
      });
      details.addEventListener('pointerleave', () => {
        if (!details.contains(document.activeElement)) details.open = false;
      });
    });
    root.querySelectorAll('.hm-footer-group').forEach(group => {
      if (footerGroups.has(group)) return;
      footerGroups.add(group);
      presentFooterGroup(group, footerNarrow.matches);
      group.querySelector('summary').addEventListener('click', event => {
        if (!footerNarrow.matches) event.preventDefault();
      });
    });
  }
  footerNarrow.addEventListener('change', () => {
    document.querySelectorAll('.hm-footer-group').forEach(group => presentFooterGroup(group, footerNarrow.matches));
  });
  document.addEventListener('pointerdown', event => {
    if (event.target.closest('.hm-navigation')) return;
    document.querySelectorAll('.hm-navigation details[open]').forEach(details => { details.open = false; });
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
